import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class ExpenseHeadMaster extends EntityDto implements IEntityDto {
    ExpenseHead_Id: string;
    ExpenseHeadName: string;
    Company_Id: string;
    CompanyName: string;
    Division_Id: string;
    DivisionName: string;
    Location_Id: string;
    LocationName: string;
    Department_Id: string;
    DepartmentName: string; 
    TotalCount: number;
    expenseHeadList :Array <any> = [];
    Parent_ExpenseHead_Id :string; 
    IsActive: boolean;
    
    constructor() {
        super();
        this.ExpenseHead_Id = "00000000-0000-0000-0000-000000000000";
        this.ExpenseHeadName = "";
        this.Company_Id = "";
        this.CompanyName = "";
        this.Division_Id = "";
        this.DivisionName = "";
        this.Location_Id = "";
        this.LocationName = "";
        this.Department_Id = "";
        this.DepartmentName = ""; 
        this.TotalCount = 0;
        this.Parent_ExpenseHead_Id = "";
        this.IsActive = true;
        
        this.EntityMetaData = [
            { FieldName: 'ExpenseHeadName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Expense Head is required' },
            { FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            { FieldName: 'Division_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division is required' },
            { FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
            { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department is required' },
        ];
    }
}
